import React from 'react';

import { Modal, useModal } from "src/components/Modal/Modal";
import Refund from "src/components/Refund/Refund";
import ContextMenu from "src/components/ContextMenu/ContextMenu";

import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./CourseSchedule.module.scss";

interface CustomTransactionCellRendererProps extends CustomCellRendererProps {
  filterDogsBySession(session: number): void
}

export const ActionsRenderer = (props: CustomTransactionCellRendererProps) => {
  const { isShown, toggle } = useModal();

  return (<div className={styles.ActionRenderer}>
    <ContextMenu
      options={[
        { 
          label: "View Dogs",
          onClick:() => {
            props.filterDogsBySession(parseInt(props.data.title.split(' ')[1]));
          }
        }
      ]}
    />
  </div>);
};
